export * from "./software-bitbucket-pricing-page.template";
export { SoftwareBitbucketPricingPageTemplate as default } from "./software-bitbucket-pricing-page.template";
